import React from "react";
import lightbulbIcon from "../assets/lightbulb_orange.svg";

interface InstructionsPanelProps {
  instructions: string[];
  className?: string;
  showImage?: boolean;
  imageComponent?: React.ReactNode;
}

const InstructionsPanel: React.FC<InstructionsPanelProps> = ({
  instructions,
  className = "",
  showImage = false,
  imageComponent,
}) => {
  return (
    <div
      className={`flex flex-col items-start bg-blue-50 rounded-lg h-fit w-full min-w-0 ${className}`}
    >
      {showImage && imageComponent && <div>{imageComponent}</div>}
      <div
        className={`font-semibold text-blue-600 ${
          showImage ? "p-6 xl:p-4 " : "p-6 pb-9 xl:p-4 xl:pb-6"
        }`}
      >
        <span
          className={`flex items-center gap-3  text-[#00143D] ${
            showImage ? "mb-5 xl:mb-3" : "mb-5"
          }`}
        >
          <img src={lightbulbIcon} alt="lightbulb" className="w-4 h-4" />
          Instructions
        </span>
        <ul className="list-disc pl-4 text-gray-700 font-dm-sans text-sm normal-case font-normal leading-6 tracking-[0.21px]">
          {instructions.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InstructionsPanel;
